import { render, staticRenderFns } from "./RenewalValue.vue?vue&type=template&id=64c29e04"
import script from "./RenewalValue.vue?vue&type=script&lang=js"
export * from "./RenewalValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports